import {Avatar, Theme, Typography} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import clsx from 'clsx';
import React, {useState} from 'react';
import {T} from 'react-polyglot-hooks';
import {getMe} from '../../../../graphql/auth';
import UserEdit from '../../../../views/Users/UserEdit';

const avatar = require('../../../../../assets/img/avatar.svg');

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        minHeight: 'fit-content',
        cursor: 'pointer',
    },
    avatar: {
        width: 60,
        height: 60,
    },
    name: {
        marginTop: theme.spacing(1)
    },
    editLink: {
        textDecoration: 'underline',
    },
}));

const Profile = (props :{ className?:string }) => {
    const {className, ...rest} = props;
    const classes = useStyles();
    const userData = getMe();
    const loading = userData.loading;
    const loggedIn = !!(userData.data && userData.data.me);
    const user = userData.data!.me;
    const [openEdit, setOpenEdit] = useState(false);
    const handleEditOpen = () => setOpenEdit(true);

    if (loading || !loggedIn) return null;

    return (
        <React.Fragment>
            <div
                {...rest}
                className={clsx(classes.root, className)}
                onClick={handleEditOpen}
            >
                <Avatar
                    alt="Person"
                    className={classes.avatar}
                    src={avatar}
                />
                <Typography
                    className={classes.name}
                    variant="h4"
                >
                    {userData.data!.me.first_name} {userData.data!.me.last_name}
                </Typography>
                <Typography variant="body1">{userData.data!.me.email}</Typography>
                <Typography variant="body2" color={'primary'} className={classes.editLink}><T phrase="edit profile"/></Typography>
            </div>
            {openEdit && <UserEdit self user={user} onClose={() => setOpenEdit(false)} open={true}/>}
        </React.Fragment>
    );
};

export default Profile;
